<app-navbar-control></app-navbar-control>

@if (!isLoaded) {
<div class="progress">
  <div class="progress-bar indeterminate"></div>
</div>
}

<section class="blogs-section">

  <div class="container">

    <div class="blogs-header text-center">



      <h1 class="section-title">
        Insights, Guides & Product Updates
      </h1>

      <p class="section-subtitle">
        Learn how to improve scheduling, reduce no-shows,
        streamline operations, and grow your business with ClockFlex.
      </p>

    </div>

    <div class="row g-4">

      @for (blog of blogs; track blog) {

      <div class="col-lg-4 col-md-6">

        <a [routerLink]="'./' + blog.slug" class="blog-card">

          <div class="blog-card-content">

            <span class="blog-badge">
              CLOCKFLEX BLOG
            </span>

            <h3>
              {{ blog.title }}
            </h3>

            <p>
              {{ blog.description }}
            </p>

            <div class="blog-footer">

              <span>
                Read Article
              </span>

              <i class="fas fa-arrow-right"></i>

            </div>

          </div>

        </a>

      </div>

      }

    </div>

  </div>

</section>